export default "<div class=\"image-container\">\n    <img [src]=\"data.imageSource\">\n</div>\n";